import { XIcon } from '@heroicons/react/solid';
import classNames from 'classnames';
import CustomLink from 'components/atoms/Link';
import layoutContext from 'components/organisms/Layout/layoutContext';
import { useContext, type FC, type ReactNode } from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import { Link } from 'react-router-dom';

const Banner: FC<{
  Icon?: FC<{ className?: string }>;
  title: string;
  description?: string;
  href?: string;
  linkLabel?: string;
  onDismiss?: () => void;
  onBannerClick?: () => void;
  extra?: ReactNode;
  bannerWrapperClassName?: string;
}> = ({
  Icon,
  title,
  description,
  href,
  linkLabel,
  onDismiss,
  onBannerClick,
  extra,
  bannerWrapperClassName,
}) => {
  const layout = useContext(layoutContext);

  const isMobileOrTablet = isMobile || isTablet;

  return (
    <div
      className={classNames(
        'fixed z-[49] bg-taxes-50 border w-full md:w-[50%] border-taxes-200 right-4 top-4 px-4 py-4 flex justify-between items-center hover:bg-taxes-100 transition-colors shadow-filters rounded-xl',
        bannerWrapperClassName,
      )}
      style={{ left: isMobileOrTablet ? 0 : layout.sidebarArea * 2 }}
    >
      <div className="flex items-center justify-between flex-1">
        {href ? (
          <Link
            to={href}
            className="flex items-center flex-1"
            onClick={onBannerClick}
          >
            {Icon ? <Icon className="w-12" /> : null}

            <div
              className={classNames('pl-5 font-semibold', {
                '!pl-0': !Icon,
              })}
            >
              <p className="font-black text-taxes-950 text-sm">{title}</p>

              <p className="text-sm font-semibold text-primary mt-3">
                {description}

                {linkLabel ? (
                  <CustomLink
                    href={href}
                    className="cursor-pointer text-taxes-500 border-b-taxes-500"
                  >
                    {linkLabel}
                  </CustomLink>
                ) : null}
              </p>
            </div>
          </Link>
        ) : (
          <div className="flex items-center flex-1" onClick={onBannerClick}>
            {Icon ? <Icon className="w-12" /> : null}

            <div
              className={classNames('pl-5 font-semibold', {
                '!pl-0': !Icon,
              })}
            >
              <p className="font-black text-taxes-950 text-sm">{title}</p>

              <p className="text-sm font-semibold text-primary mt-3">
                {description}

                {linkLabel ? (
                  <CustomLink
                    href={href}
                    className="cursor-pointer text-taxes-500 border-b-taxes-500"
                  >
                    {linkLabel}
                  </CustomLink>
                ) : null}
              </p>
            </div>
          </div>
        )}

        {extra}
      </div>

      {onDismiss ? (
        <button type="button" className="ml-10" onClick={onDismiss}>
          <XIcon className="w-5 h-5 text-taxes-300" />
        </button>
      ) : null}
    </div>
  );
};

export default Banner;
